import { render, staticRenderFns } from "./GeneralCampusAttribution.vue?vue&type=template&id=d36dab9e"
import script from "./GeneralCampusAttribution.vue?vue&type=script&lang=js"
export * from "./GeneralCampusAttribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports